import { IUser } from 'Src/ng2/shared/typings/interfaces/user.interface';

export type TClusterUserModalViewMode = 'CREATE' | 'EDIT' | 'PORTFOLIO' | 'REMOVE';

export const CLUSTER_USER_BTN_CONFIG = {
  CREATE: 'Create',
  EDIT: 'Save',
  NEXT: 'Continue',
  CREATE_LONG: 'Create user',
  EDIT_LONG: 'Save changes',
};

export interface IClusterUserIdentifier {
  name: string;
  id: string;
}

export interface IClusterUserModalShellData {
  projectionColumns?: string[];
  user?: IClusterUserIdentifier;
  mode: TClusterUserModalViewMode;
  currentUser?: IUser;
}
